import Error from '../model/Error.js';
import InvoiceTexts from '../dto/InvoiceTexts.js';
import axios from 'axios';

export default class InvoiceTextsRepository {

    static find(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/club-invoice-pdfs/texts`)
                .then(response => resolve(InvoiceTexts.fromData(response.data.data)))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static update(clubId, invoiceTexts) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/clubs/${clubId}/club-invoice-pdfs/texts`, invoiceTexts)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

}
